import { render, staticRenderFns } from "./FinCustomer.vue?vue&type=template&id=5bf32178"
import script from "./FinCustomer.vue?vue&type=script&lang=js"
export * from "./FinCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports